import React from 'react';
import { ServicePageLayout } from './ServicePageLayout';
export function TradesWebsiteDublin() {
  const content = <div className="space-y-6 text-white/80" data-id="element-1055">
      <p data-id="element-1056">
        Plumbers, carpenters, painters, landscapers — Dublin relies on its
        tradespeople. But the way people find trades has changed. The Golden
        Pages are gone. Today, if you're not on Google, you're invisible. A
        professional website is the most cost-effective tool to generate
        consistent leads for your trade business.
      </p>

      <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1057">
        Build Trust Before You Arrive
      </h2>
      <p data-id="element-1058">
        Homeowners are careful about who they let into their homes. A
        professional website with testimonials, photos of past projects, and
        clear insurance details builds instant credibility. It separates you
        from the "cowboys" and positions you as a reliable professional.
      </p>

      <h3 className="text-xl font-bold text-[#c9a84c] mt-6 mb-2" data-id="element-1059">
        What We Include for Trades
      </h3>
      <ul className="list-disc pl-6 space-y-2" data-id="element-1060">
        <li data-id="element-1061">
          <strong data-id="element-1062">Project Gallery:</strong> Show off your best work, from
          bathroom renovations to garden makeovers.
        </li>
        <li data-id="element-1063">
          <strong data-id="element-1064">Quote Request Forms:</strong> Capture leads 24/7, even when
          you're on the job.
        </li>
        <li data-id="element-1065">
          <strong data-id="element-1066">Service Areas:</strong> Target specific Dublin postcodes or
          commuter towns.
        </li>
        <li data-id="element-1067">
          <strong data-id="element-1068">WhatsApp Chat:</strong> Let customers send you photos of the
          job for quicker estimates.
        </li>
      </ul>

      <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1069">
        Invest in Your Business
      </h2>
      <p data-id="element-1070">
        For just <strong data-id="element-1071">€249</strong>, you get a digital asset that works for
        you every single day. That's less than the cost of a single small job.
        Stop relying solely on word-of-mouth and start generating your own leads
        with a professional trade website.
      </p>
    </div>;
  const faqs = [{
    q: "I'm not tech-savvy, is that okay?",
    a: 'Completely. We handle everything for you. You just tell us what you do, and we build the site. We also provide support if you need changes.'
  }, {
    q: 'Can I put my reviews on the site?',
    a: 'Yes, we highly recommend it. We can feature testimonials from your happy customers to build trust with new ones.'
  }, {
    q: 'Do I need a logo?',
    a: 'If you have one, great! If not, we can use a simple text-based logo or help you find a designer for a custom one.'
  }, {
    q: 'Can people request quotes online?',
    a: 'Yes, we include a contact form that asks for all the details you need to give a quote, sent directly to your email or WhatsApp.'
  }];
  const relatedServices = [{
    title: 'Electricians',
    href: '/services/electrician-website-dublin'
  }, {
    title: 'Barbers',
    href: '/services/barber-website-dublin'
  }, {
    title: 'Restaurants',
    href: '/services/restaurant-website-dublin'
  }, {
    title: 'Hotels',
    href: '/services/hotel-website-ireland'
  }];
  return <ServicePageLayout title="Website Design For Trades Dublin | Plumbers, Painters, Builders" metaDescription="Professional websites for Dublin tradespeople. Generate more leads and build trust with a custom site. Launch package just €249." heroTitle="Website Design For Trades Dublin" heroSubtitle="Stop chasing leads. Let customers find you with a professional website built for Irish tradespeople." content={content} faqs={faqs} relatedServices={relatedServices} data-id="element-1072" />;
}